import {
  css, ThemeProvider,
} from '@emotion/react';
import {
  type FC, type ReactNode,
} from 'react';
import { AnimatedHeroLayoutComponent } from '~/_shared/backgrounds/animatedHeroLayoutComponent';
import { LogoComponent } from '~/_shared/components/logo/logo.component';
import {
  getLogoTagLine, LogoVersion,
} from '~/_shared/components/logo/logo.helpers';
import { darkTheme } from '~/_shared/themes/dark.theme';
import type { Theme } from '~/_shared/themes/theme.model';

const formColumnStyle = css({
  width: '100%',
  display: 'flex',
  padding: '20px 10px',
  justifyContent: 'center',
  alignItems: 'center',
  '@media (min-width: 1000px)': {
    width: '55%',
  },
  '@media (min-width: 1000px) and (min-height: 600px)': {
    height: 'calc(100vh - 40px)',
  },
});

const formWrapperStyle = css({
  padding: '30px 20px 20px',
  width: '100%',
  maxWidth: 490,
  boxSizing: 'border-box',
  borderRadius: 8,
  background: 'rgba(17, 27, 34, .3)',
});

const logoWrapperStyle = css({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 32,
  alignItems: 'center',
});

const taglineStyle = (theme: Theme) => css({
  color: theme.textColors.secondary,
  cursor: 'default',
  fontSize: 12,
});

type BrandedAuthPageLayoutProps = Readonly<{
  children?: ReactNode;
  logoVersion?: LogoVersion;
}>;

export const BrandedAuthPageLayoutComponent: FC<BrandedAuthPageLayoutProps> = ({
  children,
  logoVersion = LogoVersion.variantB,
}) => {
  const tagLine = getLogoTagLine(logoVersion);

  return (
    <ThemeProvider theme={darkTheme}>
      <AnimatedHeroLayoutComponent>
        <div css={formColumnStyle}>
          <div css={formWrapperStyle}>
            <div css={logoWrapperStyle}>
              <LogoComponent width="210px" logoVersion={logoVersion} />
              {tagLine && (
                <div css={taglineStyle}>
                  {tagLine}
                </div>
              )}
            </div>
            {children}
          </div>
        </div>
      </AnimatedHeroLayoutComponent>
    </ThemeProvider>
  );
};
